import { useCallback } from 'react';

import { useLazyValidateTicketQuery } from './ticketsService';

import { useSelectedStore } from '~/api/easy-estimator-api/stores-api/useSelectedStore';

export const useLazyValidateTicket = () => {
  const [_validateTicket] = useLazyValidateTicketQuery();
  const selectedStore = useSelectedStore();

  const validateTicket = useCallback(
    async (args: { ticketNumber: string; useStore?: boolean }) => {
      const useStore = args?.useStore ?? false;

      return _validateTicket(
        useStore
          ? {
              ticketNumber: args.ticketNumber,
              storeId: selectedStore?.companyId,
            }
          : {
              ticketNumber: args.ticketNumber,
            },
        false
      );
    },
    [_validateTicket, selectedStore?.companyId]
  );

  return { validateTicket };
};
